import { PillBadge } from "@/components/ui/pill-badge";

// Sold-out marker built on the shared PillBadge (border + dot + mono
// uppercase label). Used wherever a product's capacityStatus is
// "sold_out" (docs/architecture/inventory-capacity.md) — product cards
// today, and reusable anywhere else a compact sold-out marker is needed.
export function SoldOutBadge({ className = "" }: { className?: string }) {
	return (
		<PillBadge
			label="Sold out"
			borderClassName="border-[#d8d8d2] bg-paper"
			className={className}
		/>
	);
}
